import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import classNames from 'classnames';
import Modal from 'react-responsive-modal';
import Aux from './AuxContainer'
import SelectComponent from '../components/ui/SelectComponent'
import categoryOptions from '../data/category';
import Footer from '../components/company/footer';

import agent from '../agent'

//import companyBanner from '../assets/images/check-in-expanded-01-copy-9-lukas-blazek-261681-unsplash.png'
//import companyBanner from '../assets/images/grass-blades.jpg'
//import companyBanner from '../assets/images/LCMedia_AuditionPage_BG2.jpg'
import companyBanner from '../assets/images/Space-City-Background-Image-for-Website-2018.png'
//import companyLogo from '../assets/images/LifeChurchMedia-Logo_White.png'
// import companyLogoBlack from '../assets/images/Space-city-transparent.png'
// import companyLogo from '../assets/images/Space-city-transparent.png'
import project1 from '../assets/images/mickey.jpg'
import project2 from '../assets/images/lionking.JPG'
import project3 from '../assets/images/dancers.jpg'
import project4 from '../assets/images/frozen.jpg'
import projecttest from '../assets/images/expanded-project-responsive-tesla-copy.png'
import line from '../assets/images/expanded-project--col-line-2.png'
import amlogo from '../assets/images/company-client-landing-page-auditionmagiciconplain@2x.png'

import project_details_logo1 from '../assets/images/expanded-project-shape-4@2x.png'
import project_details_logo2 from '../assets/images/check-in-expanded-01-copy-10-shape-5@2x.png'
import project_details_logo3 from '../assets/images/expanded-project-shape-6@2x.png'
import project_details_logo4 from '../assets/images/check-in-expanded-01-copy-10-shape-7@2x.png'
import project_details_logo5 from '../assets/images/expanded-project-shape-8@2x.png'
import project_details_logo6 from '../assets/images/check-in-expanded-01-copy-10-path-6@2x.png'
import project_details_logo7 from '../assets/images/check-in-expanded-01-copy-10-shape-9@2x.png'
import project_details_logo8 from '../assets/images/check-in-expanded-01-copy-10-shape-10@2x.png'
import line2 from '../assets/images/company-client-landing-page--expanded--review-line.png'

import social_media1 from '../assets/images/check-in-expanded-01-copy-9-path@2x.png'
import social_media2 from '../assets/images/expanded-project-responsive-path-3@2x.png'
import social_media3 from '../assets/images/expanded-project-shape@2x.png'
import social_media4 from '../assets/images/company-landing-page--register-path-2@2x.png'
import social_media5 from '../assets/images/expanded-project-path-3@2x.png'
import social_media6 from '../assets/images/check-in-expanded-01-copy-10-path-4@2x.png'
import social_media7 from '../assets/images/company-client-landing-page--expanded--review-path-5@2x.png'
import social_media8 from '../assets/images/check-in-expanded-01-copy-10-shape-1@2x.png'
import social_media9 from '../assets/images/company-client-landing-page--expanded--review-shape-2@2x.png'
import social_media10 from '../assets/images/check-in-expanded-01-copy-10-shape-3@2x.png'

import qrcode from '../assets/images/expanded-project-responsive-qr-code@2x.png'

const ProjectList = ({project}) => 
    <section>
        
    </section>

class Registration extends Component {

    state = {
        register: 'button header-button-selected',
        checkin: 'button header-button-unselected',
        toogleDetails: false,
        token: 'LJTH_NwzdnZ9SGsWg15r',
        showModal: false,
        pagestate: 'register',
        projects: null,
        company_landing_theme: 'dark',
        catOption: [],
        project_size: 'large-4'
    }
    componentWillMount() {
        const { location, history } = this.props
        const token = new URLSearchParams(location.search).get('token');
        let catOption = []
        if (!token) {
            history.push('/')   
        } else {
            const projects = agent.Project.myProjects(token)
            const company = projects.then(({project}) => agent.My.info(token))
            this.props.onLoad(
                Promise.all([
                    projects,
                    company
                ])
            )
            projects.then(res => {
                res.projects.map((project, index) => {
                    let cat = categoryOptions.find(k => k.value === project.category)
                    if (cat && !catOption.find(j => j.value === cat.value))
                        catOption.push(cat)
                })
                this.setState({ catOption: catOption, project_size: 'large-4' })
                if (window.innerWidth >= 2500) {
                    this.setState({ project_size: 'large-3' })
                }
            })
        }
    }

    toggleButton(value, flag) {
        if (flag === 'register'){
            this.setState({ register: 'button header-button-selected', checkin: 'button header-button-unselected', pagestate: 'register' })
        }
        if (flag === 'checkin'){
            this.setState({ register: 'button header-button-unselected', checkin: 'button header-button-selected', pagestate: 'checkin' })
        }
    }

    openProjectDetails(value, flag) {
        if (flag === 'register' && !this.state.toogleDetails) {
            this.setState({
                toogleDetails: true
            })
        } else {
          this.setState({
                toogleDetails: false
            })
        }
    }

    onOpenModal = () => {
        this.setState({ showModal: true });
    }
      
    onCloseModal = () => {
        this.setState({ showModal: false });
    }

    onChangeType(filter) {
        let projs = []
        if (filter == 0)
            projs = this.props.projects
        else
            projs = this.props.projects.filter(k => k.category === filter)
        this.setState({ projects: projs })
    }

    onChangeGender(filter) {
        let roles = []
        let projs = []

        if (filter == 'both')
          roles = this.props.roles.filter(k => k.gender == 'both' || k.gender == 'female' || k.gender == 'male')
        else
          roles = this.props.roles.filter(k => k.gender == filter || k.gender == 'both')
        roles.map((item, i) => {
          let p = this.props.projects.filter(k => k.id == item.project_id)
          projs.push(p[0])
        })
        this.setState({ projects: projs})
      }

	render(){
        const selectFix = {
          backgroundColor: '#fff'
        }
        const titleFix = {
          textAlign: 'left'
        }
        const { user, location, company } = this.props;
        let projects = this.state.projects ? this.state.projects : this.props.projects
        
        projects = this.state.pagestate === 'register' ?
            projects = projects.filter(k => k.pre_registration) : projects
        projects = this.state.pagestate === 'checkin' ?
            projects = projects.filter(k => k.checkin_enabled) : projects
        console.log('render-registration', this.props)
		return (
            <Aux>
                <div className="row main-wrapper" data-theme={company.company_landing_theme}>
                    <div className="column">
                        <div className={ classNames("row", "large-expand", { 'header-disney' : company.id == 1429 },
                        { 'header-life' : company.id == 584 }, { 'header-birthday' : company.id == 1473 },
                        { 'header' : company.id != 1429 && company.id != 584 }) }>
                            <div className="row header-details2">
                                <div className="column header-logo2">
                                {
                                    this.state.company_landing_theme === 'dark' ? 
                                        <img width="300px" src={company.logo_url}/>
                                            : <img width="300px" src={company.logo_url}/>
                                }
                                </div>
                                <div className="column header-description">
                                    <div className="header-title2">AUDITION OPPORTUNITIES</div>
                                    <div className="header-desc">LISTED BELOW ARE THE CURRENT AUDITION OPPORTUNITIES AVAILABLE TO REGISTER FOR & OPEN FOR CHECK-IN</div>
                                </div>
                                <div className="column">
                                    <button className={this.state.register} type="button" onClick={e => this.toggleButton(e.target.value, "register")}>
                                        REGISTER
                                    </button>
                                    <button className={this.state.checkin} type="button" onClick={e => this.toggleButton(e.target.value, "checkin")}>
                                        CHECK-IN
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="row project-wrapper large-expand">
                            <div className="column filters-reg">
                                <div className="row">
                                    <div style={titleFix} className="column filter-title">Filters</div>
                                </div>
                                <div className="row">
                                    <div className="column filter-column hide-content">
                                        <Field
                                          style={selectFix}
                                          name="filter_gender"
                                          className="filter-select"
                                          placeholder="ALL GENDER"
                                          component="select"
                                          onClick={(e) => this.onChangeGender(e.target.value)}>
                                            <option key='0' value='both'>GENDER</option>
                                            <option key='1' value='male'>Male</option>
                                            <option key='2' value='female'>Female</option>
                                        </Field>
                                    </div>
                                    <div className="column filter-column hide-content">
                                        <Field 
                                          name="filter_agerange"
                                          className="filter-select" 
                                          component="select">
                                          <option key={0} value={0}>AGE-RANGE</option>
                                        </Field>
                                    </div>
                                    <div className="column filter-column hide-content">
                                        <Field 
                                          name="filter_location"
                                          className="filter-select" 
                                          component="select">
                                          <option key={0} value={0}>LOCATION</option>
                                        </Field>
                                    </div>
                                    <div className="column large-4 end">
                                      <Field 
                                          style={selectFix}
                                          name="filter_type"
                                          className="filter-select"
                                          component="select"
                                          onChange={(e) => this.onChangeType(e.target.value)}>
                                          <option key={0} value={0}>ALL PROJECT TYPES</option>
                                          {
                                            this.state.catOption.map(cat => (<option key={cat.id} value={cat.value}>{cat.label}</option>))
                                          }
                                        </Field>
                                    </div>
                                </div>
                            </div>
                            <div className="column large-12 project-list">
                                {
                                    projects.length !== 0 ?
                                    projects.map((project, index) => {
                                        return (<div key={index + 1} className={classNames("column", this.state.project_size, "project", {
                                            'last-on-the-list' : (index + 1) === projects.length
                                        })}>
                                            <Link className="stretch-width" to={{
                                                pathname: '/projectdetails/' + project.id,
                                                search: location.search,
                                                state: {
                                                    projectId: project.id,
                                                    token: project.access_token,
                                                    pagestate: this.state.pagestate,
                                                    company: company
                                                }
                                            }}>
                                                <div className="img-holder">
                                                    <div className="img-holder-sub">
                                                        <img src={project.cover_url} />
                                                    </div>
                                                </div>
                                                <div className="project-name">{project.name}</div>
                                            </Link>
                                        </div>)
                                    }) : this.state.pagestate === 'register' ? 
                                        <h4 className="h4-text">There are currently no active projects available to audition for</h4> :
                                        this.state.pagestate === 'checkin' ?
                                        <h4 className="h4-text">There are currently no projects available for check-in</h4> :
                                        <h2 className="h4-text">N.A</h2>
                                }
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </Aux>
        )
	}
}

Registration = reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(Registration)

const mapStateToProps = state => ({
    projects: state.client.projects ? state.client.projects : [],
    company: state.client.company ? state.client.company : []
})


const mapDispatchToProps = (dispatch) => ({
	onLoad: payload =>
        dispatch({ type: 'COMPANY_LANDING_PAGE', payload: payload})
})

export default connect(mapStateToProps, mapDispatchToProps)(Registration)


// WEBPACK FOOTER //
// ./src/containers/Registration.js